import { SET_TRANSACTIONS } from "../actions/TransactionActions";

const initialState = {
  transactions: null,
  paymentFrom: null,
};

const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRANSACTIONS:
      return {
        transactions: action.payload,
      };

    default:
      return state;
  }
};

export default transactionReducer;
